import React, { useState, useEffect } from 'react';
import LineItemRow from './LineItemRow';
import Button from '@material-ui/core/Button';
import { useSelector } from 'react-redux';
import { pathOr } from 'ramda';
import { calculateLine } from './calculate';


export default function LineItem({ field, onChange, errors = {}, value, small = false }) {
    const { editViewTabData } = useSelector((state) => state.edit);
    const module = Object.keys(editViewTabData)[0];


    const [rowData, setRowData] = useState(field.linedata);
    // const [LineData, setLineData] = useState('');
    const [isRowAdded, setIsRowAdded] = useState(null);
    const [isRowRemoved, setIsRowRemoved] = useState(null);
    const [product_datalabels, setProduct_datalabels] = useState(pathOr([], ["linedata", "product_datalabels", 0], field));
    const [service_datalabels, setService_datalabels] = useState(pathOr([], ["linedata", "service_datalabels", 0], field));
    const enable_group = rowData.enable_group;
    const [initialValues, setInitialValues] = useState(enable_group === 0 ? pathOr([], ["linedata", "simple_data", "data"], field) : pathOr([], ["linedata", "groups_data", "data"], field));
    const [lineItems, setLineItems] = useState([]);

    const [line_attributes, setLineAttributes] = useState(
        enable_group === 1 ?
            { 'grouped': initialValues, 'deleted': [] } : { 'ungrouped': initialValues, 'deleted': [] }

    );
    // console.log("line_attributesline_attributes", line_attributes)
    useEffect(
        () => {
            // console.log("initialValuessssssss", rowData, initialValues);

            Object.keys(initialValues).map((row) => {
                let line_type = initialValues[row].line_type ? initialValues[row].line_type === 'service' ? service_datalabels : product_datalabels : initialValues[row];
                let lineData = [];
                // console.log("RRRRRRRRRRR", row, line_type)

                Object.keys(line_type).map((col) => {
                    lineData[col] = line_type[col];
                    if (line_type[col].name === "aos_products" && !Array.isArray(initialValues[row].aos_products)) {
                        lineData[col].value = initialValues[row].line_type ? { 'id': initialValues[row]["product_id"].id || '', 'value': initialValues[row]["product_id"].value || '' } : { 'id': '', 'value': '' };

                        // console.log(initialValues[row].line_type ? initialValues[row]["product_id"] : { 'id': '', 'value': '' })
                        console.log("[col]", line_type[col].value)
                    } else {
                        lineData[col].value = initialValues[row].line_type ? initialValues[row][line_type[col].name] : '';
                    }
                    // lineData.push(line_type[col]);
                })
                // console.log("lineData", lineData)
                lineItems[row] = lineData
                console.log("initialValues", initialValues)
                let calculateResult = calculateLine(initialValues[row], lineItems[row]);
                console.log("calculateResult", calculateResult)

                lineItems[row] = calculateResult.newLineData;
                initialValues[row] = calculateResult.initialValuesCalculation;
                // initialValues.push(ititialValueRow)
                // setInitialValues({ ...initialValues, ...ititialValueRow });

                // setLineItems(lineItems);
                // setLineItems({ ...lineItems, [row]: lineData })

            });
            // console.log("lineItems", lineItems)
            // onChange(line_attributes)
        },
        [rowData]
    );


    const handleChange = (field, value, lineNum) => {
        // console.log("initialValues111111111111eeeeeeeeeeeeee", initialValues)

        if (field.name === 'aos_products') {
            let productPrice = pathOr(0.00, ["rowData", "attributes", "price"], value)

            let newLineData = lineItems[lineNum];
            let lineData = []
            Object.keys(newLineData).map((col) => {
                if (newLineData[col].name === "aos_products") {
                    newLineData[col].value = { 'id': value.id || '', 'value': value.value || '' };
                    initialValues[lineNum]['aos_products'] = { 'id': value.id || '', 'value': value.value || '' };
                    initialValues[lineNum]['product_id'] = { 'id': value.id || '', 'value': value.value || '' };

                } else if (newLineData[col].name === "product_list_price" || newLineData[col].name === "product_unit_price" || newLineData[col].name === "product_total_price") {
                    newLineData[col].value = productPrice;
                    initialValues[lineNum]["product_list_price"] = productPrice;
                    initialValues[lineNum]["product_unit_price"] = productPrice;
                    initialValues[lineNum]["product_total_price"] = productPrice;

                } else if (newLineData[col].name === "part_number") {
                    newLineData[col].value = pathOr('', ["rowData", "attributes", "part_number"], value);
                    initialValues[lineNum]["part_number"] = pathOr('', ["rowData", "attributes", "part_number"], value);

                } else if (newLineData[col].name === "item_description") {
                    newLineData[col].value = pathOr('', ["rowData", "attributes", "description"], value);
                    initialValues[lineNum]["item_description"] = pathOr('', ["rowData", "attributes", "description"], value);

                } else if (newLineData[col].name === "id") {
                    newLineData[col].value = pathOr('', ["rowData", "id"], value);
                    initialValues[lineNum]["id"] = pathOr('', ["rowData", "id"], value);

                } else if (newLineData[col].name === "name") {
                    newLineData[col].value = pathOr('', ["rowData", "attributes", "name"], value);
                    initialValues[lineNum]["name"] = pathOr('', ["rowData", "attributes", "name"], value);

                } else if (newLineData[col].name === "currency_id") {
                    newLineData[col].value = pathOr('', ["rowData", "attributes", "currency_id"], value);
                    initialValues[lineNum]["currency_id"] = pathOr('', ["rowData", "attributes", "currency_id"], value);

                }

                lineData.push(newLineData[col]);
            })
            // calculateLine
            // lineItems[lineNum] = lineData;
            // let initialValuesData = initialValues[lineNum];
            // setInitialValues({ ...initialValues, [lineNum]: initialValuesData });

            // lineItems[lineNum] = lineData;
            // lineItems[lineNum] = calculateLine(initialValues[lineNum], lineItems[lineNum]);
        } else {
            initialValues[lineNum][field.name] = value;
        }
        let calculateResult = calculateLine(initialValues[lineNum], lineItems[lineNum]);
        console.log("hchangecalculateResult", calculateResult)

        lineItems[lineNum] = calculateResult.newLineData;
        initialValues[lineNum] = calculateResult.initialValuesCalculation;

        onChange(line_attributes)
        // console.log("handleChange", line_attributes)

    };

    const addRow = (type) => {
        setIsRowAdded(type)

    };
    const addGroup = () => {
        alert("AddGroup")
    }
    const showLineItems = () => {
        // alert('lineItems')
        return <>
            {lineItems && lineItems.map((data, key) => (

                <LineItemRow key={key} data={data} module={module} onChange={handleChange} initialValues={initialValues[key]} setIsRowRemoved={setIsRowRemoved} rowNum={key} />

            ))}

            <Button variant="outlined" color="primary" onClick={() => addRow('product')} style={{ marginRight: 10 }}>
                ADD PRODUCT LINE
                </Button>
            <Button variant="outlined" color="primary" onClick={() => addRow('service')}>
                ADD SERVICE LINE
                </Button>

        </>;
    }
    useEffect(() => {
        if (isRowAdded !== null) {
            let newLineData = isRowAdded === 'product' ? product_datalabels : service_datalabels;
            let lineData = newLineData
            let initialValuelineData = {}
            initialValuelineData.line_type = isRowAdded;

            // console.log("newLineData!!!!!!!!!!!11", newLineData)

            Object.keys(newLineData).map((col) => {

                if (lineData[col].name === "aos_products") {
                    // lineData[col].value = { 'id': '', 'value': value };
                    initialValuelineData[newLineData[col].name] = { 'id': '', 'value': '' };

                } else {
                    // lineData[col].value = '';
                    initialValuelineData[newLineData[col].name] = ''
                }

                // lineData.push(newLineData[col]);
            })
            // if (isRowAdded === 'product') {
            initialValuelineData.discount = "Percentage";
            initialValuelineData.vat = "0.0";
            initialValuelineData.product_discount = initialValuelineData.product_discount || "0.0";
            // }
            // console.log("newLineData before", lineItems, initialValues, initialValuelineData)

            lineItems.push(lineData);
            if (Array.isArray(initialValues)) {
                initialValues.push(initialValuelineData);

            } else {
                // initialValues.map(item => {
                //     initialValues[lineItems.length] = initialValuelineData;
                // });
                initialValues.push(initialValuelineData);

            }
            // console.log("newLineData", lineItems, initialValues)
            // 
            // setInitialValues({ ...initialValues, [initialValuesLength]: newLineData })
            // setLineItems({ ...lineItems, [lineItemsLength]: newLineData })
            // setLineItems(lineItems);
            onChange(line_attributes)

            setIsRowAdded(null);

            // console.log("lineItemsssssssssssssss", lineItems)
        }
    }, [isRowAdded])

    useEffect(() => {
        if (isRowRemoved !== null) {
            // alert(isRowRemoved)
            // lineItems[isRowRemoved]['deleted'] = 1
            // initialValues[isRowRemoved]['deleted'] = 1
            line_attributes['deleted'].push(initialValues[isRowRemoved].id)
            lineItems.splice(isRowRemoved, 1);
            initialValues.splice(isRowRemoved, 1);
            // setLineItems(lineItems);
            onChange(line_attributes)

            setIsRowRemoved(null)
            // console.log("lineItems Removed")
            // console.log("line_attributes", line_attributes)
        }
    }, [isRowRemoved])




    return (
        <>

            {enable_group ? <Button variant="outlined" color="primary" onClick={() => addGroup()}>
                ADD GROUP
                </Button> : showLineItems()}
        </>
    );
};